import { ProfileHoverCard } from "@circle-react/components/Profile/HoverCard";
import { Avatar } from "@circleco/compass/components/Avatar";

import { t } from "@/i18n-js/instance";
import { useFrameDocument } from "@/react/hooks/utils/useFrameDocument";
import type { Sender } from "@/react/types/Chat/ChatRoomMessage";
import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";

const AVATAR_CLASS_NAME = "mr-3 mt-1 self-start";

interface SenderAvatarProps {
  isLoading: boolean;
  onOpenProfile: () => void;
  sender: ChatRoomParticipant | Sender | undefined;
}

export const SenderAvatar = ({
  sender,
  isLoading,
  onOpenProfile,
}: SenderAvatarProps) => {
  const { isInFrame } = useFrameDocument();
  const isMemberProfileAvailable =
    Boolean(sender?.user_public_uid) && !sender?.is_guest;
  const isProfileButtonEnabled = isMemberProfileAvailable && !isInFrame;

  if (isLoading || !sender) {
    return <Avatar className={AVATAR_CLASS_NAME} />;
  }

  if (!isProfileButtonEnabled) {
    // No profile to open — keep the sender's photo without a trigger.
    return (
      <Avatar
        src={sender.avatar_url}
        name={sender.name}
        className={AVATAR_CLASS_NAME}
      />
    );
  }

  return (
    <ProfileHoverCard
      communityMemberId={sender.community_member_id}
      name={sender.name}
      publicUid={sender.user_public_uid}
      avatarURL={sender.avatar_url}
    >
      <Avatar
        asButton
        src={sender.avatar_url}
        name={sender.name}
        aria-label={t("messaging.open_member_profile_button_aria_label", {
          name: sender.name,
        })}
        className={AVATAR_CLASS_NAME}
        onClick={onOpenProfile}
      />
    </ProfileHoverCard>
  );
};
